import { render, staticRenderFns } from "./QuickApply.vue?vue&type=template&id=396d47c1&scoped=true"
import script from "./QuickApply.vue?vue&type=script&lang=js"
export * from "./QuickApply.vue?vue&type=script&lang=js"
import style0 from "./QuickApply.vue?vue&type=style&index=0&id=396d47c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396d47c1",
  null
  
)

export default component.exports